export default {
  grayHeader: 'よくあるご質問',
  content: {
    links: [
      '利用方法について',
      '配送について',
      '見積書、請求書、領収書について',
      'お支払いについて',
      'その他のよくあるご質問'
    ]
  },
  header: '利用方法について',
  about: [
    {
      header: '利用方法について',
      feqs: [
        {
          name: '宿泊ギフト券が使える宿はどこですか？',
          content: [
            { normal: '全国にある星野リゾート運営の宿でご利用いただけます。' }
          ],
          detail: [
            {
              normal:
                '※ 現在、星野リゾート運営の海外の宿ではご利用いただけません。詳しくは本サイトの『宿泊ギフト券が使える宿』をご確認願います。',
              isAnnotation: true
            }
          ]
        },
        {
          name: 'どうやって使いますか？',
          content: [
            {
              normal:
                'お電話もしくは宿の予約サイトにて、ギフト券番号をご申告またはご入力の上でご予約いただき、'
            },
            {
              line:
                'ご宿泊当日に必ず宿のフロントスタッフにギフト券をお渡しください。'
            }
          ],
          detail: [
            { normal: '詳しくは' },
            { link: ['コチラ', '/about/gift'] },
            { normal: 'でご確認いただけます。' }
          ]
        },
        {
          name: '宿泊ギフト券が使えない日はありますか？',
          content: [
            {
              normal: '宿泊ギフト券は有効期間内であれば使えない日はありません。'
            }
          ]
        },
        {
          name:
            '2部屋以上や3人以上での予約、あるいは2泊以上の宿泊にも利用可能ですか？',
          content: [
            {
              normal:
                'はい。ご予約いただくお部屋の数や人数、その他宿泊日数や宿泊プランなどに制限はなくギフト券を適用可能です。'
            }
          ],
          detail: [
            {
              normal:
                '※ ただし、券面額以上のご精算があった際にはご宿泊者様が残りのご利用額をお支払いすることとなります。',
              isAnnotation: true
            }
          ]
        },
        {
          name: '海外にある星野リゾートの宿でも使えるの？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、現在海外にある星野リゾートの宿ではご利用いただけません。'
            }
          ]
        },
        {
          name: '星野リゾートの航空券・新幹線・レンタカー付きプランでも使えるの？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、現在星野リゾートの航空券・新幹線・レンタカー付きプランにはご利用いただけません。'
            }
          ]
        },
        {
          name: '旅行代理店や宿泊予約サイトの予約でも使えるの？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、旅行代理店及び宿泊予約サイトでご予約いただいた場合にはご利用いただけません。'
            }
          ]
        },
        {
          name: '宿泊当日に宿泊ギフト券を持ってくることを忘れたらどうなるの？',
          content: [
            {
              normal:
                '万が一、宿泊ギフト券のご持参をお忘れの場合には券面額を現金等の手段によりお支払いいただく事となりますのでくれぐれもお忘れのないようにご注意ください。'
            }
          ]
        },
        {
          name: '宿泊ギフト券は使った後、持って帰れるの？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、宿泊ギフト券の提出後は弊社にて管理させていただくためお返しできません。予めご了承願います。'
            }
          ]
        },
        {
          name: '宿泊はしないけどレストランやお土産購入に利用できますか？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、ご宿泊にのみご利用いただけます。<br />なお、ご宿泊時にお部屋付けにさせていただいたレストラン利用やお土産購入にはご利用いただけます。'
            }
          ]
        },
        {
          name: 'お釣りは出ますか？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、宿泊ギフト券利用時に現金等によってお釣りをお出しすることは出来かねますので、ご注意ください。'
            }
          ]
        },
        {
          name: '紛失や破損した場合に再発行できますか？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、ご購入後の再発行は出来かねますのでご注意ください。'
            }
          ]
        }
      ]
    },
    {
      header: '配送について',
      feqs: [
        {
          content: [
            { normal: '配送に関しましては' },
            {
              link: ['コチラ', '/about/delivery']
            },
            { normal: 'をご確認願います。' }
          ]
        }
      ]
    },
    {
      header: '見積書、請求書、領収書について',
      feqs: [
        {
          content: [
            {
              normal: '見積書、領収書は本サイト上の「'
            },
            {
              link: ['注文確認', '/mypage/login']
            },
            {
              normal:
                '」ページにて発行可能です。<br />請求書は銀行振込でご購入の方のみ、注文完了後にメールにて「請求書発行Eメール」をお送りいたします。'
            }
          ]
        }
      ]
    },
    {
      header: 'お支払いについて',
      feqs: [
        {
          name: 'クレジットカード支払いはできますか？',
          content: [
            {
              normal:
                'はい。本サイトではVISA/MASTER/JCB/AMEX/DINERSカードがご利用いただけます。'
            }
          ]
        },
        {
          name: '法人名義での請求書発行はできますか？',
          content: [
            {
              normal:
                'はい。請求書はご注文時に宛名をご指定いただけます。'
            }
          ]
        },
        {
          name:
            '銀行振込をしたが、振込依頼人名を間違えた。ちゃんと購入できますか？',
          content: [
            {
              normal:
                '請求書発行Eメールに記載の口座に、請求金額が正しく入金されている場合は、振込時依頼人名が違っていても問題ございません。'
            }
          ],
          detail: [
            {
              normal:
                'ご入金の確認が完了するまでは出荷されませんので予めご了承願います。'
            }
          ]
        },
        {
          name: '銀行振込時の支払い口座情報はどこに載っていますか？',
          content: [
            {
              normal:
                'お支払い先の口座情報はご注文完了後に弊社からお送りする「請求書発行Eメール」にてお知らせいたします。<br />口座はご注文毎に異なります。'
            }
          ]
        },
        {
          name: '支払い期限を過ぎてしまった場合はどうすれば良いですか？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、支払い期限を過ぎた場合はご注文のキャンセル扱いとなりますため、再度ご注文画面よりお申込み願います。'
            }
          ]
        }
      ]
    },
    {
      header: 'その他のよくあるご質問',
      feqs: [
        {
          name: '商品のキャンセル・返品・交換はできますか？',
          content: [
            {
              normal:
                '誠に恐れ入りますが、ご購入後のキャンセル・返品・交換は承れませんのでご注意ください。'
            }
          ],
          detail: [
            {
              normal:
                '※ 銀行振込のお客様は振込期限が過ぎるとご注文のキャンセル扱いとなります。',
              isAnnotation: true
            }
          ]
        },
        {
          name: '注文完了メールが届かないのですが。',
          content: [
            {
              normal:
                '注文完了メールが届かない場合には本サイトの「注文確認」ページにてご購入が完了しているかご確認願います。'
            }
          ],
          detail: [
            {
              normal:
                '※ 「注文確認」ページのログインにはご注文完了時に画面に表示されるID・パスワードが必要となります。',
              isAnnotation: true
            }
          ]
        },
        {
          name: '購入した宿泊ギフト券の封筒内には何が入っていますか？',
          content: [
            {
              normal:
                '封筒内には、宿泊ギフト券(ご購入枚数)・メッセージカード(1枚)・お客様利用規約(1枚)が入っております。'
            }
          ]
        },
        {
          name: '一度に複数の宛先に送れますか？',
          content: [
            {
              normal:
                'はい。ご注文時にお届け先毎に、ご購入枚数・有効期間・メッセージカード・配送情報を入力いただけます。'
            }
          ]
        },
        {
          name:
            '同じ内容の宿泊ギフト券を複数セット購入するにはどうすれば良いですか？',
          content: [
            {
              normal:
                'ご注文時に、先に入力したご注文セットをコピーして追加することが可能です。'
            }
          ]
        },
        {
          name:
            '複数の人に贈るが、手渡ししたいので先ずは全て自分宛に送ることはできますか？',
          content: [{ normal: 'はい。お届け先は自由に設定可能です。' }],
          detail: [
            {
              normal:
                '※ 配送料はお届け先住所や差出人情報が同一であれば同時に何セットご購入いただいても1ヶ所の配送料で発送可能です。',
              isAnnotation: true
            }
          ]
        },
        {
          name: '購入は電話や宿のフロントでもできますか？',
          content: [
            { normal: '大変恐れ入りますが、購入は本サイトでのみ承ります。' }
          ]
        },
        {
          name: 'キャンペーンやプロモーション景品として利用したいのですが。',
          content: [
            {
              normal:
                '法人様において製品やサービスの販売促進等を目的として、星野リゾート宿泊ギフト券の名称及び星野リゾートに関する名称や画像を用いてこれらのイベントを行う事を検討されている方は'
            },
            {
              link: ['コチラ', '/contact']
            },
            { normal: 'のお問い合わせフォームよりご連絡願います。' }
          ]
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/i18n/ja/faq.js